<template>
	<div>
		<apeiron-product-list
			v-if="['apeiron_uat', 'apeiron'].includes($store.state.tenantId)"
		/>
		<default-product-list v-else />
	</div>
</template>

<script>
import DefaultProductList from "../components/DefaultProductList"
import ApeironProductList from "../components/mockedApeiron/ApeironProductList"

export default {
	components: {
		DefaultProductList,
		ApeironProductList
	}
}
</script>
